import { render } from "./InitHeader.vue?vue&type=template&id=a9fb8e68"
import script from "./InitHeader.vue?vue&type=script&lang=js"
export * from "./InitHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__